import fetch from "@/fetch";
// 查询结果
export const getInquriy = params => {
  return fetch({
    method: "post",
    url: "/focus/motion/inventory/select_goods",
    data: params
  });
};
// 查询经销商名称列表
export const getDealerName = params => {
  return fetch({
    method: "post",
    url: "/focus/motion/pricequery/getUserNameByUserCode",
    data: params
  });
};
